import { useState } from 'react';

/**
 * Hook para controlar formulário com limpeza automática ao alterar campos definidos.
 *
 * @param {Object} valoresIniciais - Objeto com os valores iniciais do formulário.
 * @param {Array<string>} camposQueResetam - Lista de nomes de campos que, ao serem alterados, resetam todo o formulário.
 * @returns {[formData, setFormData, handleChange]} - Retorna o estado, a função de atualização direta e a função handleChange automatizada.
 */
export function useFormularioComReset(valoresIniciais, camposQueResetam = []) {
    const [formData, setFormData] = useState(valoresIniciais);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => {
            // Se for um campo que reseta o formulário, reinicia com o novo valor
            if (camposQueResetam.includes(name)) {
                return {
                    ...valoresIniciais,
                    [name]: value
                };
            }

            // Caso contrário, atualiza normalmente
            return {
                ...prev,
                [name]: value
            };
        });
    };

    return [formData, setFormData, handleChange];
}
